import { MenuItem, OutlinedTextFieldProps, SelectProps, TextField } from '@mui/material';
import Txt from '@/components/ui/Txt';
import { FieldOption } from '@/lib/parsers/form';

export type DefaultSelectFieldProps = Partial<OutlinedTextFieldProps> & {
  options?: FieldOption[];
};

export const DefaultSelectField = ({
  options = [],
  SelectProps: maybeSelectProps,
  ...props
}: DefaultSelectFieldProps) => {
  const selectProps: SelectProps = {
    ...maybeSelectProps,
  } as SelectProps;

  const isNative = !!selectProps.native;

  return (
    <TextField value="" select SelectProps={selectProps} {...props}>
      {options?.map(({ value, label }) =>
        isNative ? (
          <option key={value} value={value}>
            {label}
          </option>
        ) : (
          <MenuItem key={value} value={value}>
            <Txt variant="large">{label}</Txt>
          </MenuItem>
        )
      )}
    </TextField>
  );
};
